import PropTypes from 'prop-types';
import UserSidebarItems from './UserSidebarItems';

export const PermissionsColumn = ({ localTipoUsuario, hiddenItems, updateHiddenItems }) => {
    return (
        <div className="col-12 col-sm-6">
            <div className="admin-list-card admin-permisos-card h-100 overflow-hidden">
                <div className="card-header bg-light bg-opacity-50 border-bottom py-3 px-3">
                    <h5 className="mb-0 fw-semibold text-dark">Permisos de acceso</h5>
                    <p className="small text-muted mb-0 mt-1">Módulos visibles para este usuario.</p>
                </div>
                <div className="card-body p-3">
                    <UserSidebarItems
                        tipoUsuario={localTipoUsuario}
                        previousHiddenItems={hiddenItems}
                        updateHiddenItems={updateHiddenItems}
                    />
                </div>
            </div>
        </div>
    );
}
PermissionsColumn.propTypes = {
    localTipoUsuario: PropTypes.number,
    hiddenItems: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    updateHiddenItems: PropTypes.func,
}